import { render, staticRenderFns } from "./mpxuzhi.vue?vue&type=template&id=060702b0&scoped=true&"
import script from "./mpxuzhi.vue?vue&type=script&lang=js&"
export * from "./mpxuzhi.vue?vue&type=script&lang=js&"
import style0 from "./mpxuzhi.vue?vue&type=style&index=0&id=060702b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060702b0",
  null
  
)

export default component.exports